// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"189":"c73449a00231b553","639":"2fc548780821cae0","825":"b3c2b965edbb358d"}[chunkId] + ".js";
};